/**
 * Represents an attachment with its blob name and resolved URL
 */
export interface AttachmentWithUrl {
    /**
     * The blob name stored in CouchDB
     */
    blobName: string;

    /**
     * The file name of the attachment
     */
    fileName: string;

    /**
     * The resolved SAS URL for accessing the blob
     */
    url: string;

    /**
     * Whether the URL was successfully resolved
     */
    isResolved: boolean;

    /**
     * Error message if URL resolution failed
     */
    errorMessage?: string;

    /**
     * Content type of the attachment
     */
    contentType: string;

    /**
     * Size of the attachment
     */
    fileSize: number;

    /**
     * Type of attachment (attachment, signature, etc.)
     */
    attachmentType: string;
}

/**
 * Contains resolved attachment URLs organized by type
 */
export class ResolvedAttachments {
    /**
     * Attachment upload attachments with URLs
     */
    uploads:Record<string, AttachmentWithUrl[]> = {};

    /**
     * Signature attachments with URLs
     */
    signatures: Record<string, AttachmentWithUrl[]> = {};

    /**
     * Check if there are any attachments
     */
   hasUploads: boolean = false;

    /**
     * Total attachment count
     */
   
    totalAttachmentCount: number = 0;
}

